import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <div className={styles.itemSelling}>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1725594353754/pc_ksp_03.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1725594353754/pc_ksp_03.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1725594664241/m_ksp_03.jpg"
            />
            <div className="item-desc-c">
                <div className="item-line-1">{t('c_ms1')}</div>
                <div className="item-line-2">{t('c_ms2')}</div>
            </div>
        </div>
    );
}
